export const ROWS_PER_PAGE_OPTIONS = [10, 25, 50];
export const ROWS_PER_PAGE_DROPDOWN_OPTIONS = ROWS_PER_PAGE_OPTIONS.map((v) => ({ key: `${v}`, value: v }));

export const COLUMN_OPTIONS = [
  { key: "id", name: "Id" },
  { key: "title", name: "Title" },
  { key: "name", name: "Name" },
  { key: "email", name: "Email" },
  { key: "is_anonymous", name: "Anonymous" },
  { key: "summary", name: "Summary" },
  { key: "rating_feedback", name: "Rating" },
  { key: "text_feedback", name: "Feedback" },
  { key: "topics", name: "Topics" },
  { key: "created_at", name: "Date" },
];

export const COLUMNS_NOT_TO_ENABLE_AT_LOAD = ["id", "summary", "text_feedback"];
